import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoRitoAlternativo } from '../../../../common/models/tipologiche/tipo-rito-alternativo';

export class FascicoloRitiAlternativi extends FascicoloFull {
  sezione: string;
  tipoRitoAlternativo: TipoRitoAlternativo;
  numeroRegistroGeneraleAffariPenali: string;
  giudiceIndaginiPreliminari: string;
  giudiceUdienzaPreliminare: string;
  pubblicoMinistero: string;
  prove: string;
  sufficienzaProve: boolean;
  misureCautelari: boolean;
  misuraAdottata: string;
  richiestaOblazione: boolean;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
